import { useMemo } from 'react';
import { GraphOptionItemProps } from '../types'
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material'
import { KeyOfTargetListCategory } from 'features/search/targetList/util';

export const GraphOptionRankItem = <T,>({
	option,
	options,
	configure,
  targetList,
	graphType,
	setOptionValue
}: GraphOptionItemProps<T>) => {
  const { rankList, first } = useMemo(
		() => {
      const rankList = Object.keys(configure.axis).filter((a) => configure.axis[a].isRank === true)
      const first = rankList.length > 0 ? rankList[0] : undefined
      return { rankList, first }
    },
		[configure.axis]
	)
  return (
    <FormControl>
      <InputLabel id={`rank-${option.id}-label`}>{option.label}</InputLabel>
      <Select
        labelId={`rank-${option.id}-label`}
        label={option.label}
        id={`rank-${option.id}`}
        size="small"
        value={
          options.find((opt) => opt.id === option.id)?.value ??
          (option.nullable ? '**' : option.default ?? first ?? '')
        }
        onChange={(event) =>
          setOptionValue(option.id, event.target.value)
        }
      >
        { option.nullable && (
          <MenuItem key={`choice-empty`} value="**">
            なし
          </MenuItem>
        ) }
        { rankList.map((axisType) => {
          const def = configure.axis[axisType]
          if (graphType && def.validGraph && def.validGraph.indexOf(graphType) < 0) return <></>
          return (
            <MenuItem key={`rank-${axisType}`} value={axisType}>
              {def.title}
            </MenuItem>
          )
        }) }
        {targetList?.category?.map((category, i) =>
          <MenuItem
            key={`rank-category-${i}-${category.sequence}`}
            value={`${KeyOfTargetListCategory}${category.sequence}`}
          >
            {category.title}
          </MenuItem>
        )}
      </Select>
    </FormControl>
  )
}